"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlayerPrefs = exports.savePlayerPrefs = exports.getPlayerPrefs = exports.defaultSubtitlePreference = void 0;
var React = __importStar(require("react"));
var cookies_1 = __importDefault(require("../utils/cookies"));
var PLAY_PREFS_KEY = 'cueplayer-react-prefs';
exports.defaultSubtitlePreference = {
    id: null,
    kind: null,
    label: 'off',
    language: null,
};
var defaultPlayerPreferences = {
    volumeRate: 80,
    playbackRate: 1,
    autoplay: false,
    videoQuality: {
        bitrate: null,
        height: null,
        id: 'auto',
        width: null,
    },
    subtitle: exports.defaultSubtitlePreference,
    muted: false,
    theater: false,
    defaultView: 'transcript',
    activeSidebarTab: 0,
};
var getPlayerPrefs = function () {
    if (typeof window === 'undefined') {
        return defaultPlayerPreferences;
    }
    return (cookies_1.default.get(PLAY_PREFS_KEY) ||
        cookies_1.default.set(PLAY_PREFS_KEY, defaultPlayerPreferences));
};
exports.getPlayerPrefs = getPlayerPrefs;
var savePlayerPrefs = function (options) {
    return cookies_1.default.set(PLAY_PREFS_KEY, __assign(__assign(__assign({}, defaultPlayerPreferences), (0, exports.getPlayerPrefs)()), options));
};
exports.savePlayerPrefs = savePlayerPrefs;
var usePlayerPrefs = function () {
    var _a = React.useState((0, exports.getPlayerPrefs)()), playerPrefs = _a[0], setPlayerPrefs = _a[1];
    var setPlayerPrefsOptions = React.useCallback(function (options) {
        console.debug('setting player prefs', { options: options });
        var newPrefs = (0, exports.savePlayerPrefs)(options);
        setPlayerPrefs(newPrefs);
    }, []);
    return __assign({ setPlayerPrefs: setPlayerPrefsOptions, getPlayerPrefs: React.useCallback(exports.getPlayerPrefs, []) }, playerPrefs);
};
exports.usePlayerPrefs = usePlayerPrefs;
